// extracted by mini-css-extract-plugin
export default {"nav":"AccountNav-module_nav__MqdI7","list":"AccountNav-module_list__xGG9j"};